import {Autocomplete, Checkbox} from '@fullscreendigital/carrefour-dex-fe'
import { TableFiltersType } from '@fullscreendigital/carrefour-dex-fe/dist/cjs/components/Table/Table'
import { AsyncAutocompleteOption } from 'components/core-ui/AsyncAutocomplete/AsyncAutocompleteDefinitions'
import { Radio } from "@mui/material";

export const tableColumns = ['Tip de livrare directă', 'Tip de livrare PAXD', 'Tip de livrare via hub', 'Acceptă Retur Marfă']

export const buildColumns = ({
                               formik,
                               toggleDeliveryDeposit,
                               toggleDeliveryType,
                               toggleAcceptReturns,
                               depositList,
                               hubList}: {
  formik: any,
  toggleDeliveryDeposit: Function,
  toggleDeliveryType: Function,
  toggleAcceptReturns: Function,
  depositList: any,
  hubList: any
}) => [
  {
    title: 'Depozit',
    field: 'deliveryDeposit',
    render: row => (
        <Checkbox
            edge="start"
            checked={row.deposit!==null || row.paxdDeposit!==null || row.receptionHub!==null}
            onChange={() => toggleDeliveryDeposit(row, (event.target as HTMLInputElement).checked)}
            inputProps={{ 'aria-labelledby': `employee-${row.value}` }}
            label={row.deliveryDeposit.name}
            style={{ fontSize: '12px !important' }}
        />
    )
  },
  {
    title: 'Tip de livrare directă',
    field: 'deposit',
    render: row => (
        <Radio
            name="delivery"
            checked={row.deliveryMatrixType==="DIRECT"}
            onChange={() => toggleDeliveryType(row, "DIRECT")}
            disabled={row.deposit===null && row.paxdDeposit===null && row.receptionHub===null}
            value='DIRECT'
            style={{ fontSize: '12px !important' }}
        />
    )
  },
  {
    title: 'Tip de livrare PAXD',
    field: 'paxdDeposit',
    render: row => (
        <div>
          <Radio
              name="delivery"
              checked={row.deliveryMatrixType==="PAXD"}
              onChange={() => toggleDeliveryType(row, "PAXD")}
              value='PAXD'
              disabled={row.deposit===null && row.paxdDeposit===null && row.receptionHub===null}
              style={{ fontSize: '12px !important' }}
          />
          <Autocomplete
              variant="outlined"
              label="Depozite"
              disableClearable
              disabled={row.deliveryMatrixType!=="PAXD"}
              onChange={(event, option) => {
                row.paxdDeposit={name: option.label, id: option.value};
                toggleDeliveryType(row, "PAXD");
              }}
              value={(row.paxdDeposit!==null) ? row.paxdDeposit.name : null}
              options={depositList || []}
          />
        </div>
    )
  },
  {
    title: 'Tip de livrare via hub',
    field: 'hub',
    render: row => (
        <div>
          <Radio
              name="delivery"
              checked={row.deliveryMatrixType==="HUB"}
              onChange={() => toggleDeliveryType(row, "HUB")}
              value='HUB'
              disabled={row.deposit===null && row.paxdDeposit===null && row.receptionHub===null}
              style={{ fontSize: '12px !important' }}
          />
          <Autocomplete
              variant="outlined"
              label="Huburi"
              disableClearable
              disabled={row.deliveryMatrixType!=="HUB"}
              onChange={(event, option) => {
                row.receptionHub={name: option.label, id: option.value, address: '', type: 'HUB', active: true, code: ''};
                toggleDeliveryType(row, "HUB");
              }}
              value={(row.receptionHub!==null) ? row.receptionHub.name : null}
              options={hubList || []}
          />
        </div>
    )
  },
  {
    title: 'Accepta retur de marfa',
    field: 'acceptReturns',
    render: row => (
        <Checkbox
            edge="start"
            checked={row.acceptReturns}
            onChange={() => toggleAcceptReturns(row)}
            disabled={row.deposit===null && row.paxdDeposit===null && row.receptionHub===null}
            inputProps={{ 'aria-labelledby': `employee-${row.value}` }}
            style={{ fontSize: '12px !important' }}
        />
    )
  },

]

export const drawerFilters = ({
     shopOptions,
     hubOptions,
     depositOptions
   }: {
     shopOptions: AsyncAutocompleteOption[]
     hubOptions: AsyncAutocompleteOption[]
     depositOptions: AsyncAutocompleteOption[]
   }): TableFiltersType[] => [
  {
    name: 'shopCode',
    value: '',
    filter: (
      <Autocomplete
        variant="outlined"
        label="Selectează magazin"
        disableClearable
        options={shopOptions || []}
      />
    ),
    type: 'autocomplete',
    label: 'Selectează magazin'
  },
  {
    name: 'depositId',
    value: '',
    filter: (
      <Autocomplete
        variant="outlined"
        label="Selectează depozit"
        disableClearable
        options={depositOptions || []}
      />
    ),
    type: 'autocomplete',
    label: 'Selectează depozit'
  },
  {
    name: 'hubId',
    value: '',
    filter: (
      <Autocomplete
        variant="outlined"
        label="Selectează hub"
        disableClearable
        options={hubOptions || []}
      />
    ),
    type: 'autocomplete',
    label: 'Selectează hub'
  }
]
